import { Pipe, PipeTransform } from '@angular/core';
import { Directive, HostListener, ElementRef, OnInit } from '@angular/core';

@Directive({
  selector: '[wmDecimalPercent]'
})
export class WmDecimalPercentDirective implements OnInit {

  private el: HTMLInputElement;

  constructor(
    private elementRef: ElementRef
  ) {
    this.el = this.elementRef.nativeElement;
  }

  ngOnInit() {
    this.el.value = this.transform(this.el.value);
  }

  @HostListener('focus', ['$event.target.value'])
  onFocus(value) {
    this.el.value = this.transform(value);
  }

  @HostListener('blur', ['$event.target.value'])
  onBlur(value) {
    this.el.value = this.transform(value);
  }

  transform(value) {
    if (!!value) {
      value = parseFloat(0 + value.replace(',', '.'));
      value = value.toFixed(1);
      if (value <= 0 || value >= 100) {
        return null;
      } else {
        return value;
      }
    } else {
      return null;
    }
  }
}

@Directive({
  selector: '[wmDecimalAmount]'
})
export class WmDecimalAmountDirective implements OnInit {

  private el: HTMLInputElement;

  constructor(
    private elementRef: ElementRef
  ) {
    this.el = this.elementRef.nativeElement;
  }

  ngOnInit() {
    this.el.value = this.transform(this.el.value);
  }

  @HostListener('focus', ['$event.target.value'])
  onFocus(value) {
    this.el.value = this.transform(value);
  }

  @HostListener('blur', ['$event.target.value'])
  onBlur(value) {
    this.el.value = this.transform(value);
  }

  transform(value) {
    if (!!value) {
      value = parseFloat(0 + value.replace(',', '.'));
      value = value.toFixed(2);

      if (value <= 0) {
        return null;
      } else {
        return value;
      }
    } else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/decimal.directive.ts